import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadSpecializations, loadSpecializationsFailure, loadSpecializationsSuccess } from './specializations.actions';
import { ApplicationUsersService } from '@app/core/services/application-users.service';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { IPaginationParams, ISpecialization } from '@interfaces';
import { SpecializationsService } from '@services';

@Injectable()
export class SpecializationsEffect {
  constructor(
    private actions$: Actions,
    private specializationServices: SpecializationsService,
    private _toast: ToastrService,
  ) {}
  loadSpecializations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSpecializations),
      mergeMap(() =>
        this.specializationServices.getAllSpecializations({ pageNum: 1, pageLimit: 'all' } as IPaginationParams).pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const specializations = response.data.map((item: ISpecialization) => ({
                id: item._id,
                name: item.name.hebrew,
                hebrewName: item.name.hebrew,
                arabicName: item.name.arabic,
              }));
              return loadSpecializationsSuccess({ specializations });
            } else {
              this._toast.error(response.message);
              return loadSpecializationsFailure({ error: '[Specializations] Load Specializations Failure' });
            }
          }),
          catchError((error) => {
            this._toast.error(error || error.message);
            return of(loadSpecializationsFailure({ error: '[Specializations] Load Specializations Failure' }));
          }),
        ),
      ),
    ),
  );
}
